import type {
  AssignPlanToOrganizationRequest,
  AssignPlanToOrganizationResponse,
  CreatePlanRequest,
  ListPlansResponse,
  ListSubscriptionInvoicesResponse,
  PlanResponse,
  RecordManualSubscriptionPaymentRequest,
  RecordManualSubscriptionPaymentResponse,
  UpdatePlanRequest,
} from '@jq4race/shared';

import { request } from './client.js';

// ── Plan CRUD — saas-monetization-plans v2 (super_admin) ────────────────────

/** POST /super-admin/plans */
export async function createPlan(input: CreatePlanRequest): Promise<PlanResponse> {
  return request<PlanResponse>('/super-admin/plans', { method: 'POST', body: input });
}

/** GET /super-admin/plans */
export async function listPlans(): Promise<ListPlansResponse> {
  return request<ListPlansResponse>('/super-admin/plans', { method: 'GET' });
}

/** PATCH /super-admin/plans/:id */
export async function updatePlan(id: string, input: UpdatePlanRequest): Promise<PlanResponse> {
  return request<PlanResponse>(`/super-admin/plans/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: input,
  });
}

/** POST /super-admin/plans/:id/deactivate */
export async function deactivatePlan(id: string): Promise<PlanResponse> {
  return request<PlanResponse>(`/super-admin/plans/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST',
  });
}

/** POST /super-admin/plans/:id/activate */
export async function activatePlan(id: string): Promise<PlanResponse> {
  return request<PlanResponse>(`/super-admin/plans/${encodeURIComponent(id)}/activate`, {
    method: 'POST',
  });
}

/** PUT /super-admin/organizations/:orgId/plan — assign or reassign a plan. */
export async function assignPlanToOrganization(
  orgId: string,
  input: AssignPlanToOrganizationRequest,
): Promise<AssignPlanToOrganizationResponse> {
  return request<AssignPlanToOrganizationResponse>(
    `/super-admin/organizations/${encodeURIComponent(orgId)}/plan`,
    { method: 'PUT', body: input },
  );
}

// ── manual-subscription-billing (WU8) — super_admin invoice visibility + manual payment recording ──

/** GET /super-admin/organizations/:orgId/subscription/invoices */
export async function listOrganizationSubscriptionInvoices(
  orgId: string,
): Promise<ListSubscriptionInvoicesResponse> {
  return request<ListSubscriptionInvoicesResponse>(
    `/super-admin/organizations/${encodeURIComponent(orgId)}/subscription/invoices`,
    { method: 'GET' },
  );
}

/**
 * POST /super-admin/organizations/:orgId/subscription/invoices/:invoiceId/record-payment
 * Records an offline (manual) payment against a specific open invoice.
 */
export async function recordManualSubscriptionPayment(
  orgId: string,
  invoiceId: string,
  input: RecordManualSubscriptionPaymentRequest,
): Promise<RecordManualSubscriptionPaymentResponse> {
  return request<RecordManualSubscriptionPaymentResponse>(
    `/super-admin/organizations/${encodeURIComponent(orgId)}/subscription/invoices/${encodeURIComponent(invoiceId)}/record-payment`,
    { method: 'POST', body: input },
  );
}
